<div style="margin-top: 3%">
    <div class="section-heading">
        <h2 class="h2_font_size">Spin n Win</h2>
        <div class="hr" style="padding: 4px;"></div>
    </div>

    <div class="offer-banner" (click)="onFloatingButtonClick('Trending Now')">
        <span class="emoji">🎁</span>
        <span class="auto-type" id="offerText" #offerText></span>
    </div>
</div>

<!-- Navigation bar with three buttons -->
<div class="nav-bar">
    <button class="nav-btn" [ngClass]="{ 'nav-btn-active': activeTab === 'home' }" (click)="filterCoupons('home')">
        AVAILABLE
        <div class="coupon-message">{{homeCount}} Products</div>
    </button>
    <button class="nav-btn" [ngClass]="{ 'nav-btn-active': activeTab === 'redeemed' }"
        (click)="filterCoupons('redeemed')">
        REDEEMED
        <div class="coupon-message">{{redeemedCount}} Products</div>
    </button>
</div>

<div class="container">
    <div class="row">
        <div class="col-md-12">
            <div class="container">
                <div class="row">
                    <div class="col-lg-2 col-md-3 col-sm-3 col-xs-6" style="padding: 0;"
                        *ngFor="let product of discountProducts;">
                        <div class="product_detaiils">
                            <!--Card-->
                            <div class="card card-cascade wider">
                                <!--Card image-->
                                <a>
                                    <div class="view overlay hm-white-slight">
                                        <img src="../../../../assets/img/{{ product.productDetails.productImage }}"
                                            class="img-fluid" alt="Image not found" width="360px" height="300px"
                                            onerror="this.src='../../../../assets/img/defaultCake.webp';"
                                            [routerLink]="['/product', product.productCode]" />
                                        <img *ngIf="product.productDetails.foodType == 'Veg'"
                                            class="img-responsive img_align" src="../../../../assets/img/Veg.webp"
                                            alt="" />
                                        <img *ngIf="product.productDetails.foodType == 'Non-Veg'"
                                            class="img-responsive img_align" src="../../../../assets/img/Nonveg.webp"
                                            alt="" />
                                    </div>
                                </a>

                                <div class="card-body text-center">
                                    <p class="card-title product_name">
                                        <strong style="height: 80%;">
                                            <a [routerLink]="['/product', product.productCode]"
                                                routerLinkActive="router-link-active">
                                                {{product.productDetails.productName }}</a>
                                        </strong>
                                        <strong class="price_style">
                                            <span>₹ {{ product.productDetails.price | number: "1.2-2"
                                                }}</span>
                                        </strong>
                                    </p>

                                    <p>
                                        <!-- <span>{{product?.productDetails?.portion_Weight }}</span> -->
                                    </p>

                                    <div class="card-footer">
                                        <button type="button" class="add_to_cart_btn luck-btn-animate"
                                            (click)="tryMyLuck(product)" *ngIf="product.status == null">
                                            <span class="spin-icon"><img src="assets/img/spintowin.png"
                                                    alt="Shuffling..." width="100" /></span> Spin to Win
                                        </button>

                                        <button type="button" class="add_to_cart_btn luck-btn-animate claim-btn"
                                            (click)="tryMyLuck(product)" *ngIf="product.status == 'Generated'">
                                            <i class="fas fa-gift"></i>
                                            Claim Reward
                                        </button>

                                        <!-- <button type="button" class="add_to_cart_btn luck-btn-animate claim-btn"
                                            (click)="showRewardDetails(product)" *ngIf="product.status == 'Redeemed'">
                                            <i class="fas fa-gift"></i>
                                            Reward Details
                                        </button> -->

                                        <div *ngIf="product.status == 'Redeemed'">
                                            <h3 class="redeemed-discount-text">Here’s what you claimed</h3>

                                            <!-- Product Reward -->
                                            <div class="product-preview"
                                                *ngIf="product.redeemedDetails.redeemedType === 'Product'">
                                                <img [src]="'../../../../assets/img/' + product.redeemedDetails?.productDetails?.productImage"
                                                    alt="Reward Product" />
                                                <p class="product-name-modal line-height">
                                                    <strong>{{ product.redeemedDetails?.productDetails?.productName
                                                        }}</strong><br />
                                                    <span class="price_style">₹{{
                                                        product.redeemedDetails?.productDetails?.price |
                                                        number: '1.2-2' }}</span>
                                                </p>
                                            </div>

                                            <!-- Cash Reward -->
                                            <div class="product-preview"
                                                *ngIf="product.redeemedDetails.redeemedType === 'Value'">
                                                <img src="../../../../assets/img/cashflow.gif" alt="Cash Reward"
                                                    class="cash-image" />
                                                <p class="product-name-modal line-height">
                                                    <strong>Cash Discount</strong><br />
                                                    <span class="price_style">₹{{ product.redeemedDetails?.value
                                                        }}</span>
                                                </p>
                                            </div>

                                            <!-- Rate Us Section -->
                                            <div class="rate-us-section">
                                                <ngb-rating [(rate)]="product.redeemedDetails.rating" [max]="5"
                                                    [readonly]="product.redeemedDetails.isRated">
                                                    <ng-template let-fill="fill">
                                                        <span class="custom-star">
                                                            <i class="fa"
                                                                [ngClass]="{ 'fa-smile': fill > 50, 'fa-smile-o': fill <= 50 }"></i>
                                                        </span>
                                                    </ng-template>
                                                </ngb-rating>

                                                <!-- Submit only if not rated already -->
                                                <button *ngIf="!product.redeemedDetails.isRated"
                                                    class="submit-rating-btn"
                                                    (click)="submitRating(product.redeemedDetails)">
                                                    Rate Us
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="date_time_div">
                                    <span class="date_time_style" *ngIf="product.status === 'Redeemed'">
                                        Redeem On:
                                        {{ product.redeemedDetails?.redeemedDate | date: 'dd MMM yyyy hh:mm a' }}
                                    </span>
                                    <span class="date_time_style" *ngIf="product.status !== 'Redeemed'">
                                        Valid Till: {{ product.toDateTime | date: 'dd MMM yyyy hh:mm a' }}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Luck Result Modal -->
                    <div class="luck-modal" *ngIf="showLuckModal">
                        <div class="luck-content">
                            <canvas #confettiCanvas class="confetti-canvas"></canvas>

                            <button class="close-btn" (click)="closeModal('home')">×</button>

                            <!-- SHUFFLE ANIMATION BLOCK -->
                            <ng-container *ngIf="isShuffling; else rewardContent">
                                <div class="shuffling-block">
                                    <h2 class="loading-text">🎁 Loading your deal...</h2>
                                    <div class="shuffle-animation">
                                        <img src="assets/img/spintowin.png" alt="Shuffling..." width="100" />
                                    </div>
                                </div>
                            </ng-container>

                            <!-- ORIGINAL CONTENT BLOCK -->
                            <ng-template #rewardContent>
                                <h2 class="win-text animate-bounce-in">🎉 Congratulations! 🎉</h2>
                                <ng-container *ngIf="selectedRewardProduct?.status === 'Generated'; else newlyWon">
                                    <h3 class="discount-text">Rewards ready to claim!</h3>
                                </ng-container>
                                <ng-template #newlyWon>
                                    <h3 class="discount-text">Claim Your New Deal</h3>
                                </ng-template>

                                <div class="reward-options">
                                    <!-- Product Reward -->
                                    <button class="reward-btn" (click)="onRewardTypeChange('product')"
                                        [class.active]="selectedRewardType === 'product'">
                                        <div class="reward-column">
                                            <div class="product-preview">
                                                <img [src]="'../../../../assets/img/' + selectedRewardProduct?.productDetails?.productImage"
                                                    alt="product" />
                                            </div>
                                            <span class="reward-title">{{
                                                selectedRewardProduct?.productDetails.productName }}</span>
                                            <span class="reward-subtext">
                                                ₹{{ selectedRewardProduct?.productDetails.price | number: "1.2-2" }}
                                            </span>
                                        </div>
                                    </button>

                                    <span class="or_text">OR</span>

                                    <!-- Money Reward -->
                                    <button class="reward-btn" (click)="onRewardTypeChange('money')"
                                        [class.active]="selectedRewardType === 'money'">
                                        <div class="reward-column">
                                            <div class="product-preview">
                                                <img src="../../../../assets/img/cashflow.gif" alt="Cash Reward"
                                                    class="cash-image" />
                                            </div>
                                            <span class="reward-title">Cash Discount</span>
                                            <span class="reward-subtext">₹{{ wonDiscount }}</span>
                                        </div>
                                    </button>
                                </div>

                                <p class="choose-message" *ngIf="!selectedRewardType">Please choose one reward to
                                    proceed</p>

                                <!-- <div class="product-preview" *ngIf="selectedRewardType === 'product'">
                                    <img [src]="'../../../../assets/img/' + selectedRewardProduct?.productDetails?.productImage"
                                        alt="product" />
                                    <p class="card-title product-name-modal">
                                        <strong><span>{{selectedRewardProduct?.productDetails?.productName
                                                }}</span></strong>
                                        <strong class="price_style"><span>₹ {{
                                                selectedRewardProduct?.productDetails?.price |
                                                number: "1.2-2" }}</span></strong>
                                    </p>
                                </div> -->

                                <!-- Cash Preview (if money is selected) -->
                                <!-- <div class="product-preview" *ngIf="selectedRewardType === 'money'">
                                    <img src="../../../../assets/img/cashflow.gif" alt="Cash Reward"
                                        class="cash-image" />
                                    <p class="card-title product-name-modal">
                                        <strong><span>Cash Discount Reward</span></strong>
                                        <strong class="price_style"><span>₹{{ wonDiscount }}</span></strong>
                                    </p>
                                </div> -->


                                <div class="qr-wrapper" *ngIf="selectedRewardType">
                                    <qrcode [qrdata]="qrData" [width]="150" [backgroundColor]="'transparent'">
                                    </qrcode>
                                </div>

                                <p class="scan-note" *ngIf="selectedRewardType">Show this QR code at our store to claim
                                    your deal.</p>
                            </ng-template>
                        </div>
                    </div>

                    <!-- <div class="luck-modal" *ngIf="showRewardDetailsModal">
                        <div class="luck-content">
                            <button class="close-btn" (click)="closeRewardDetails()">×</button>

                            <div>
                                <h2 class="win-text animate-bounce-in">🎉 You've Already Won! 🎉</h2>
                                <h3 class="redeemed-discount-text">Here’s what you claimed</h3>

                                <div class="product-preview" *ngIf="redeemedDetails.redeemedType === 'Product'">
                                    <img [src]="'../../../../assets/img/' + redeemedDetails?.productDetails?.productImage"
                                        alt="Reward Product" />
                                    <p class="product-name-modal" style="line-height: 10px;
">
                                        <strong>{{ redeemedDetails?.productDetails?.productName }}</strong><br />
                                        <span class="price_style">₹{{ redeemedDetails?.productDetails?.price |
                                            number: '1.2-2' }}</span>
                                    </p>
                                </div>

                                <div class="product-preview" *ngIf="redeemedDetails.redeemedType === 'Value'">
                                    <img src="../../../../assets/img/cashflow.gif" alt="Cash Reward"
                                        class="cash-image" />
                                    <p class="product-name-modal">
                                        <strong>Cash Discount</strong><br />
                                        <span class="price_style">You won ₹{{ redeemedDetails?.value }}</span>
                                    </p>
                                </div>

                                <div class="rate-us-section">
                                    <h3 class="rate-title">How was your reward experience?</h3>

                                    <ngb-rating [(rate)]="redeemedDetails.rating" [max]="5"
                                        [readonly]="redeemedDetails.isRated">
                                        <ng-template let-fill="fill">
                                            <span class="custom-star">
                                                <i class="fa"
                                                    [ngClass]="{ 'fa-smile': fill > 50, 'fa-smile-o': fill <= 50 }"></i>
                                            </span>
                                        </ng-template>
                                    </ngb-rating>

                                    <button *ngIf="!redeemedDetails.isRated" class="submit-rating-btn"
                                        (click)="submitRating(redeemedDetails)">
                                        Submit Rating
                                    </button>

                                    <p class="thanks-text" *ngIf="redeemedDetails.isRated">
                                        ⭐ Thank you for your feedback!
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div> -->

                </div>
            </div>
        </div>
    </div>
</div>

<div class="col-md-12">
    <h4 *ngIf="wait && discountProducts.length === 0&& isAgreedTerms" class="empty">
        <i class="i-style">
            No Discounts Are Currently Available
        </i>
    </h4>
    <h4 *ngIf="!wait" class="empty"><i class="i-style">Loading...</i></h4>
    <h4 *ngIf="wait && !isAgreedTerms" class="empty"><i class="i-style">Agree to the
            <button type="button" style="border: none; padding: 0; color: blue" (click)="openPrivacyPolicyDialog()">
                <u>terms and conditions</u>
            </button>
            to get Coupons
        </i>
    </h4>

</div>
<div *ngIf="!showLuckModal" class="floating-side-button" (click)="onFloatingButtonClick('Best Deals')">
    BEST DEALS
</div>
<!-- Left Floating Info Button -->
<!-- <div class="floating-left-info-button" (click)="openInfoDialog()">
    <span class="material-icons">info</span>
</div> -->
<!-- Info Tab Floating Button -->
<div class="slide-info-tab" *ngIf="!infoDialogOpened && isAgreedTerms && !showLuckModal" (click)="openInfoDialog()"
    [class.attention]="showBounce">
    <!-- <span class="material-icons">info</span> -->
    <span class="info-text">Terms</span>
</div>